import request from '../request.js'

// 冻结卡列表查询
export function listFrozenCard(params) {
    return request({
        url: 'frozenCard/list.do',
        method: 'post',
        data: params
    })
}

// 冻结卡导出
export function exportFrozenCard(params) {
    return request({
        url: 'frozenCard/export.do',
        method: 'post',
        data: params
    })
}

// 冻结卡批量导入
export function batchImportSync(params) {
    return request({
        url: 'frozenCard/batchImportSync.do',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 冻结卡批量删除
export function batchDeleteSync(params) {
    return request({
        url: 'frozenCard/batchDeleteSync.do',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: {'Content-Type': 'multipart/form-data'}
    })
}

// 冻结卡单个删除
export function deleteById(params) {
    return request({
        url: 'frozenCard/deleteById.do',
        method: 'post',
        data: params
    })
} 